var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mydakalist" }, [
    _c(
      "div",
      { staticClass: "list" },
      [
        _vm._l(_vm.list, function (house, index) {
          return _c("house-item", {
            key: index,
            attrs: { house: house, type: house.type == "zulin" ? 3 : 2 },
            on: { handleHosue: _vm.handleHosue },
          })
        }),
        _vm._v(" "),
        _vm.hasMore
          ? _c("div", { staticClass: "next", on: { click: _vm.nextPage } }, [
              _vm._v("下一页"),
            ])
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _vm.list.length == 0
      ? _c("div", { staticClass: "list-null" }, [_vm._v(" 暂无数据 ")])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }